import styled from 'styled-components';
import colors from 'constants/colors';

export const RecordsContainer = styled.div`
  width: calc(100% + 32px);  
  margin: 8px -16px 0 -16px;
  
  table {
    width: 100%;
    border-collapse: separate; 
    text-align: left;
    border-spacing: 0 16px; 

    th {
      color: ${colors.silver};
      font-size: 12px;
      padding: 0 16px;
    }

    td {
      color: ${colors.white};
      font-size: 14px;
      font-weight: 600;
      background-color: ${colors.black5};
      padding: 16px;
    }
  }
`;

export const NavigatorContainer = styled.div`
  display: flex;
  justify-content: space-between;
  column-gap: 10px;

  /* @media only screen and (max-width: 1200px) {
    justify-content: center;
  } */
`;

export const Navigator = styled.div`
  color: ${colors.lightBlue};
  font-size: 13px;
  font-weight: bold;
  cursor: pointer;

  /* @media only screen and (max-width: 1200px) {
    display: none;
  } */

  ${(props) => props.disabled ? `
    pointer-events:none;
    color: ${colors.dimGrey}
  `: null }
`;

// export const Swiper = styled.div`
//   color: ${colors.lightBlue};
//   font-size: 18px;
//   font-weight: bold;
//   cursor: pointer;

//   @media only screen and (min-width: 1200px) {
//     display: none;
//   }

//   @media only screen and (max-width: 767px) {
//     font-size: 13px;
//   }

//   ${(props) => props.disabled ? `
//     pointer-events:none;
//     color: ${colors.dimGrey}
//   `: null }
// `;